import React, { memo } from 'react';
import { InventoryCountStatus as status } from 'types/inventory';
import { InventoryCountTabProps } from './InventoryCount.props';
import { InventoryTabContent } from './InventoryTabContent';

export const ReadyForReportInventory = memo<InventoryCountTabProps>((props) => {
  return (
    <InventoryTabContent
      status={status.READY_FOR_REPORT}
      {...props}></InventoryTabContent>
  );
});
